import {useState, useEffect} from 'react';
import {Pagination} from 'antd';
import './index.css';
import {useTranslation} from 'react-i18next';
import newsItems from './data';
import newsItems_en from './data_en';
import newsItems_vi from './data_vi';

const PhoneIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4a2 2 0 0 1 1.99-2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.02z"/>
    </svg>
);

const MailIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="20" height="16" x="2" y="4" rx="2"/>
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
    </svg>
);

const LocationIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
        <circle cx="12" cy="10" r="3"/>
    </svg>
);

const WhatsAppIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
    </svg>
);

function InsideInfo() {
    const pageSize = 5;
    const [currentPage, setCurrentPage] = useState(1);
    const [currentData, setCurrentData] = useState([]);
    const {t, i18n} = useTranslation();

    useEffect(() => {
        const lang = i18n.language;
        if (lang.startsWith('en')) {
            setCurrentData(newsItems_en);
        } else if (lang.startsWith('vi')) {
            setCurrentData(newsItems_vi);
        } else {
            setCurrentData(newsItems);
        }
    }, [i18n.language]);

    const currentNewsItems = currentData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <div className="inside-section">
            <div className="inside-inner">
                <div className="inside-header">
                    <div className="inside-header-tag">XIAOMAI</div>
                    <h2>{t('news_contact_title')}</h2>
                    <div className="inside-header-line" />
                </div>

                <div className="inside-grid">
                    {/* 新闻 */}
                    <div className="news-block">
                        <div className="news-list">
                            {currentNewsItems.map((item, i) => (
                                <a
                                    key={i}
                                    className="news-item"
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="news-date">
                                        {t('news_label')}
                                    </div>
                                    <div className="news-item-inner">
                                        <div className="news-content">
                                            <h4 className="news-title">{item.title}</h4>
                                            <p className="news-excerpt">{item.content}</p>
                                        </div>
                                        <img className="news-img" src={item.image} alt={item.title} />
                                    </div>
                                </a>
                            ))}
                        </div>
                        <div className="news-pagination">
                            <Pagination
                                current={currentPage}
                                onChange={setCurrentPage}
                                total={currentData.length}
                                pageSize={pageSize}
                                size="small"
                            />
                        </div>
                    </div>

                    {/* 联系我们 */}
                    <div className="contact-block">
                        <div className="contact-card">
                            <div className="contact-card-header">
                                <div className="contact-gold-line" />
                                <div>
                                    <div className="contact-card-en">Reach Us</div>
                                    <div className="contact-card-title">{t('inside_contact')}</div>
                                </div>
                            </div>

                            <ul className="contact-list">
                                <li className="contact-item">
                                    <span className="contact-icon"><PhoneIcon /></span>
                                    <div className="contact-text">
                                        <span className="contact-label">{t('inside_hotline')}</span>
                                        <span className="contact-value">400-050-1183</span>
                                    </div>
                                </li>
                                <li className="contact-item">
                                    <span className="contact-icon"><MailIcon /></span>
                                    <div className="contact-text">
                                        <span className="contact-label">{t('inside_email')}</span>
                                        <span className="contact-value">
                                            <a href="mailto:gnaturepowdef@gmail.com">gnaturepowdef@gmail.com</a>
                                        </span>
                                    </div>
                                </li>
                                <li className="contact-item">
                                    <span className="contact-icon"><LocationIcon /></span>
                                    <div className="contact-text">
                                        <span className="contact-label">{t('inside_jiangxi_factory')}</span>
                                        <span className="contact-value">{t('inside_jiangxi_factory_value')}</span>
                                    </div>
                                </li>
                                <li className="contact-item">
                                    <span className="contact-icon"><LocationIcon /></span>
                                    <div className="contact-text">
                                        <span className="contact-label">{t('inside_dongguan_factory')}</span>
                                        <span className="contact-value">{t('inside_dongguan_factory_value')}</span>
                                    </div>
                                </li>
                                <li className="contact-item">
                                    <span className="contact-icon"><WhatsAppIcon /></span>
                                    <div className="contact-text">
                                        <span className="contact-label">WhatsApp</span>
                                        <span className="contact-value">+86 18929131303</span>
                                    </div>
                                </li>
                            </ul>

                            <div className="contact-img-wrap">
                                <img
                                    className="contact-img"
                                    src="/files/images/companybg.jpg"
                                    alt="factory"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InsideInfo;